module.exports = __webpack_public_path__ + "img/smartpost-gray.35fcefac.png";